import { app } from './Api';

const getProfiles = async (qtd_per_page = '', page = '') => {
    return app.get(`perfil?page=${page}&qtd_per_page=${qtd_per_page}`);
};

export { getProfiles };
